import { drawing as d } from '@progress/kendo-drawing';
import { VisualBase } from './VisualBase';
import { MarkerPathMixin } from './MarkerPathMixin';
import { createSegment } from './utils';
import { Point } from './../math';
/**
 * Represents a line segment with marker capabilities.
 * Extends VisualBase and incorporates MarkerPathMixin functionality.
 */
export class Line extends VisualBase {
    /**
     * Creates a new Line instance.
     * @param options - Configuration options for the line including endpoints and styling
     */
    constructor(options) {
        super(options);
        /** @hidden */
        this._capMap = MarkerPathMixin._capMap;
        this.container = new d.Group();
        this._getPath = MarkerPathMixin._getPath.bind(this);
        this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
        this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
        this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
        this._createMarker = MarkerPathMixin._createMarker.bind(this);
        this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
        this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
        this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
        this._initPath();
        this._createMarkers();
        this._initAccessibility();
    }
    /**
     * Returns the drawing container for this line.
     * @returns The drawing container
     */
    drawingContainer() {
        return this.container;
    }
    /**
     * Redraws the line with updated options.
     * @param options - Updated configuration options
     */
    redraw(options) {
        if (options) {
            options = options || {};
            const from = options.from;
            const to = options.to;
            if (from) {
                this.options.from = from;
            }
            if (to) {
                this.options.to = to;
            }
            if (from || to) {
                this._drawPath();
                this._redrawMarkers(true, options);
            }
            else {
                this._redrawMarkers(false, options);
            }
            super.redraw(options);
        }
    }
    /**
     * @hidden
     * Initializes the path drawing element.
     */
    _initPath() {
        const options = this.options;
        const drawingElement = this.drawingElement = new d.Path({
            stroke: options.stroke
        });
        this._fill();
        this._drawPath();
        this.container.append(drawingElement);
    }
    /**
     * @hidden
     * Draws the line path between from and to points.
     */
    _drawPath() {
        const options = this.options;
        const drawingElement = this.drawingElement;
        const from = options.from || new Point();
        const to = options.to || new Point();
        drawingElement.segments.elements([
            createSegment(from.x, from.y),
            createSegment(to.x, to.y)
        ]);
    }
}
